<!--新增/编辑收货地址 @zjf-2021-01-06-->
<template>
  <div class="address_operate_modal">
    <el-dialog :title="changeType?'添加收货地址':'添加新地址'" v-model="modalVisible" @close="close_dialog">
      <el-form :model="form.data" :rules="rules" ref="ruleForm">
        <el-form-item  :label="changeType?'收货人':'收件人'"  :label-width="formLabelWidth"  prop="memberName" >
          <el-input
            v-model="form.data.memberName"
            autocomplete="off"
            maxlength="25"
            show-word-limit
            :placeholder="changeType?'请输入收货人姓名':'请输入收件人姓名'"
            clearable
          >
          </el-input>
        </el-form-item>
        <el-form-item  label="电话"  :label-width="formLabelWidth"   prop="telMobile"  v-if="addressType1!='2'||addressType1!=2" >
          <el-input
            v-model="form.data.telMobile"
            autocomplete="off"
            placeholder="请输入电话号码"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item  label="电话"  :label-width="formLabelWidth"     v-if="addressType1=='2'||addressType1==2"  >
          <el-input
            v-model="form.data.telMobile"
            autocomplete="off"
            placeholder="请输入电话号码"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item
          label="邮编"
          :label-width="formLabelWidth"
          prop="Postcode"
        >
          <el-input
            v-model="form.data.Postcode"
            autocomplete="off"
            placeholder="请输入邮编"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="邮箱" :label-width="formLabelWidth" prop="mailbox">
          <el-input
            v-model="form.data.mailbox"
            autocomplete="off"
            placeholder="请输入邮箱"
            clearable
          ></el-input>
        </el-form-item>
         <el-form-item
          v-if="changeType"
          label="地址类别"
          :label-width="formLabelWidth"
          prop="changeType"
        >
          <el-select v-model="addressTypeArrayValue" placeholder="请选择所地址类别" @change="changeaddressTypeArray">
            <el-option
              v-for="item in addressTypeArray"
              :key="item.id"
              :label="item.name"
              :value="item.name"
            >
            </el-option>
          </el-select>
          <!-- <el-input
            disabled
            autocomplete="off"
            :placeholder="(addressType1==1||addressType1=='1')?'国内仓地址':'海外仓地址'"
            clearable
          ></el-input> -->
        </el-form-item>
        <el-form-item
          label="所在地区"
          :label-width="formLabelWidth"
          prop="area"
        >
          <el-cascader
            ref="cascaderAddr"
            v-model="form.data.area"
            :options="areaDataArray"
            placeholder="请选择所在地区"
            :props="cascaderProps"
            clearable
          ></el-cascader>
        </el-form-item>
        <el-form-item
          label="详细地址"
          :label-width="formLabelWidth"
          prop="detailAddress"
        >
          <el-input
            type="textarea"
            :rows="2"
            maxlength="252"
            v-model="form.data.detailAddress"
            autocomplete="off"
            placeholder="请输入详细地址"
            clearable
          ></el-input>
        </el-form-item>
        

        <el-form-item label=" " :label-width="formLabelWidth">
          <el-checkbox v-model="form.data.isDefault">设为默认地址</el-checkbox>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="close_dialog">取 消</el-button>
          <el-button type="primary" @click="addAddress('ruleForm')">确 定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ref, reactive, getCurrentInstance, watchEffect,onMounted } from "vue";
 import {useRouter} from "vue-router";
// import areaData from "../assets/area.json";
import { ElMessage } from "element-plus";
export default {
  name: "SldAddressOperation",
  components: {},
  props: ["visibleFlag", "type", "addressInfo","addressType","changeType"],
  setup(props, { emit }) {
    const { proxy } = getCurrentInstance();
     const router = useRouter();
    const formLabelWidth = "80px";
    const modalVisible = ref(true);
    const form = reactive({ data: {} });
    const areaDataArray =ref([]);
    const cascaderProps = { label: "regionName", value: "regionCode" };
    const ruleForm = ref(null);
    const cascaderAddr = ref(null);
    const addressType1 = ref(props.addressType)
    const addressTypeArray = ref([{id:0,name:'国内仓地址'},{id:1,name:'海外仓地址'}]);
    const addressInfo = reactive(props.addressInfo);
    const addressTypeArrayValue = ref(null);
    const addressTypeIndex = ref(null);
    if (props.type == "edit") {
      var area = [];
      form.data.memberName = addressInfo.data.memberName;
      form.data.telMobile = addressInfo.data.telMobile;
      form.data.detailAddress = addressInfo.data.detailAddress; //详细地址
      form.data.mailbox=addressInfo.data.email//邮箱
      form.data.Postcode=addressInfo.data.zipCode//邮编
      form.data.isDefault = addressInfo.data.isDefault ? true : false; //是否默认地址：1-默认地址，0-非默认地址
      area.push(
        addressInfo.data.provinceCode,
        addressInfo.data.cityCode,
        addressInfo.data.districtCode,
        addressInfo.data.countryCode
      );
      form.data.area = area;
    } else {
      form.data.memberName = "";

      form.data.telMobile = "";
      form.data.mailbox="",//邮箱
      form.data.Postcode="",//邮编
      form.data.detailAddress = ""; //详细地址
      form.data.isDefault = false; //是否默认地址：1-默认地址，0-非默认地址
      form.data.area = [];
    }

    const rules = {
      memberName: [
        { required: true, message: "请输入收货人", trigger: "change" },
        { min: 2, max: 25, message: "请输入2~25个字符", trigger: "change" },
      ],
      telMobile: [
        { required: true, message: "请输入手机号", trigger: "change" },
        // {
        //   pattern:/^((\+?86)|(\(\+86\)))?(13[012356789][0-9]{8}|15[012356789][0-9]{8}|18[012356789][0-9]{8}|17[012356789][0-9]{8}|147[0-9]{8}|1349[0-9]{7}|199[0-9]{9})$/,
        //   message: "请输入正确的手机号",
        //   trigger: "change",
        // },
      ],
      Postcode: [{  message: "请输入邮编", trigger: "change" }],
      mailbox: [{  message: "请输入邮箱", trigger: "change" }],
      area: [{ required: true, message: "请选择所在地区", trigger: "change" }],
      detailAddress: [
        { required: true, message: "请输入详细地址", trigger: "change" },
        { min: 0, max: 252, message: "请输入0~252个字符", trigger: "change" },
      ],
    }; //输入校验
    //增加地址
    
    const addAddress = () => {
      console.log(cascaderAddr.value.getCheckedNodes())
      console.log(form.data.area)
      ruleForm.value.validate((valid) => {
        console.log(form.data)
        
        if (valid) {
          var param = {
            provinceCode: form.data.area[0],
            cityCode: form.data.area[1],
            districtCode:form.data.area[2],
            // districtCode: form.data.area[3],
            // countryCode:form.data.area[0],
            countryCode:form.data.Postcode,
            memberName: form.data.memberName,
            countryName: cascaderAddr.value .getCheckedNodes()[0].pathLabels[0],
            email: form.data.mailbox,
            zipCode: form.data.Postcode,
            addressType:props.addressType,//國内地址
            telMobile: form.data.telMobile,
            addressAll: cascaderAddr.value .getCheckedNodes()[0].pathLabels.join(""),
            cityName: cascaderAddr.value .getCheckedNodes()[0].pathLabels[1],
            districtName: cascaderAddr.value .getCheckedNodes()[0].pathLabels[2],
            provinceName:cascaderAddr.value .getCheckedNodes()[0].pathLabels[0],
            isDefault: form.data.isDefault ? 1 : 0,
            detailAddress: form.data.detailAddress,
          };

          // console.log(cascaderAddr.value .getCheckedNodes(),111111)
          var url;
          if (props.type == "edit") {
            url = "v3/member/front/memberAddress/edit";
            param.addressId = addressInfo.data.addressId;
          } else if (props.type == "add") {
            url = "v3/member/front/memberAddress/add";
          }
          proxy
            .$post(url, param)
            .then((res) => {
              if (res.state == 200) {
                close_dialog();
                emit("refreshAddress", param, res.data, props.changeType);
                ElMessage.success(res.msg);
                    if(!props.changeType) {
                      router.push({path: `/member/address/list`});
                    }
              } else {
                ElMessage(res.msg);
              }
            })
            .catch(() => {
              //异常处理
            });
        } else {
          return false;
        }
      });
    };
    const close_dialog = () => {
      emit("close");
      document.body.style.overflow = "visible";
    };
    const citey = () => {
      if(props.addressType == '2'){
        proxy
        .$get("/v3/system/front/region/getOverSeasList")
        .then((res) => {
          areaDataArray.value =res.data
        });
      }else{
        proxy
        .$get("/v3/system/front/region/getList")
        .then((res) => {
          areaDataArray.value =res.data
        });
      }
    };
    const changeaddressTypeArray =()=>{
      if(!addressTypeIndex.value){
        if(props.addressType=='2'||props.addressType==2){
          addressTypeIndex.value = '1'
        }else{
          addressTypeIndex.value = '2'
        }
      }else{
        addressTypeIndex.value = (addressTypeIndex.value=='1')?'2':'1';
      }
      console.log(addressTypeIndex.value)
      areaDataArray.value = [];
      form.data.area.value = null;
      form.data.detailAddress = null;
      if(addressTypeIndex.value=='1'||addressTypeIndex.value==1){
         proxy
        .$get("/v3/system/front/region/getList")
        .then((res) => {
          areaDataArray.value =res.data
        });
      }else{
        proxy
        .$get("/v3/system/front/region/getOverSeasList")
        .then((res) => {
          areaDataArray.value =res.data
        });
      }
    };
    onMounted(() => {
      citey();
      console.log('addressType:' + props.addressType)
      console.log('changeType:' + props.changeType)
      addressTypeArrayValue.value = (props.addressType=='1'||props.addressType==1)?'国内仓地址':'海外仓地址'
    });
    watchEffect(() => {
      //   modalVisible.value = props.visibleFlag;
      
    });
    return {
      formLabelWidth,
      modalVisible,
      form,
      areaDataArray,
      cascaderProps,
      rules,
      ruleForm,
      addAddress,
      cascaderAddr,
      close_dialog,
      citey,
      addressType1,
      addressTypeArray,
      addressTypeArrayValue,
      addressTypeIndex,
      changeaddressTypeArray
    };
  },
};
</script>

<style lang="scss">
.el-cascader-menu__wrap {
  height: 204px !important;
}

.address_operate_modal {
  .el-dialog {
    width: 600px !important;
  }

  .el-cascader {
    width: 100% !important;
  }

  .el-checkbox {
    .el-checkbox__input {
      margin-top: -4px;
    }
  }

  .el-button--primary {
    color: #fff;
    background-color: $colorMain;
    border-color: $colorMain;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: $colorMain;
    border-color: $colorMain;
  }

  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: $colorMain;
  }

  .el-button {
    padding: 9px 20px;
  }

  .el-dialog__body {
    padding: 20px;
  }

  .el-form-item {
    margin-bottom: 15px;
  }

  .el-form-item__content {
    position: relative;
  }

  .el-form-item__error {
    position: absolute;
    top: 16px;
    right: 25px;
    display: inline-block;
    width: auto;
    z-index: 2;
    background: #fff;
    left: auto;
    padding: 0 3px;
  }

  input::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    color: #ccc;
    font-size: 12px;
  }

  input::-moz-placeholder {
    /* Firefox 19+ */
    color: #ccc;
    font-size: 12px;
  }

  input:-ms-input-placeholder {
    /* IE 10+ */
    color: #ccc;
    font-size: 12px;
  }

  input:-moz-placeholder {
    /* Firefox 18- */
    color: #ccc;
    font-size: 12px;
  }

  textarea::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    color: #ccc;
    font-size: 12px;
  }

  textarea::-moz-placeholder {
    /* Firefox 19+ */
    color: #ccc;
    font-size: 12px;
  }

  textarea:-ms-input-placeholder {
    /* IE 10+ */
    color: #ccc;
    font-size: 12px;
  }

  textarea:-moz-placeholder {
    /* Firefox 18- */
    color: #ccc;
    font-size: 12px;
  }
}
</style>